const url = require('./../config/dev.uri').BASE_URI
const target = require('./../config/proxy-mock')[url].target
export default {
  // 渲染 loading 组件前的等待时间。默认：50ms.
  ROUTER_LOADING_DALAY: 50,
  // 最长等待时间。超出此时间( 5s )则渲染 error 组件。默认：Infinity
  ROUTER_LOADING_TIMEOUT: 5000,

  EVENT_TOKE: 'Authorization',
  AJAX_SUCCESS: 200,
  RES_CODE: 0, // 成功
  RES_CODE1: -1, // 失败
  NO_TOKEN: 401,
  INVALID_TOKEN: -101,
  NO_PERMISSION: 403,
  URL_IMG: 'https://d.cdn.tpr.ndlink.cn',
  // URL_IMG: target,
  // WEBSOCKET_URL: 'ws://127.0.0.1:48080',
  WEBSOCKET_URL: 'wss://baoji.tpr.ndlink.cn',
  URL_DOWN: target,
  PAYURL: 'https://pay.tpr.ndlink.cn',
  PUBLICKEY: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCPFEsnBkvTsZ+ceTTpBa3+kjJGEebOs1wJ8sZwpxi6EVDFckHV+heHDZ8Uk8w1G4tm/M72qA2O/5N2ECp2OvplhUrC/YqcGJNQNswlDB4JG39vq0mQjNSIN3X/v6Ig754PAWDi93YUCsd5ZxoFbjliD4vsgOWeWtIILPwbeoiNTwIDAQAB'
}



// WEBPACK FOOTER //
// ./src/constant.js